module.exports = __webpack_public_path__ + "img/medium-ship-wreck-2.8498f770.png";